import {
  Component,
  ElementRef,
  Input,
  Renderer2,
  ChangeDetectorRef,
  EventEmitter,
  Output
} from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import {
  STORE_ENDORSEMENT,
  UPDATE_ENDORSEMENT_STEP2
} from '@store/sat-motor/sat-motor.action';
import { Store, Select } from '@ngxs/store';
import { Router } from '@angular/router';
import { SatMotorState } from "@store/sat-motor/sat-motor.state";
import { SharedModule } from "../../../shared/shared.module";
import { NxSmallStageModule } from '@aposin/ng-aquila/small-stage';
import { NxDialogService, NxModalRef } from '@aposin/ng-aquila/modal';
import { TextFieldModule } from '@angular/cdk/text-field';
import { formatNumber } from "@angular/common";
import { SimpleModalComponent } from "@shared/components/modal/simple-modal/simple-modal.component";
import { Observable, Subject, takeUntil } from "rxjs";
import { FormatDecimalPipe } from "@shared/pipes/format-decimal/format-decimal.pipe";
import { RemoveCommaPipe } from "@shared/pipes/remove-comma/remove-comma.pipe";
import { SumInsuredFormatterDirective } from "@shared/directives/sum-insured/sum-insured-formatter.directive";
import { OkMessageComponent } from "../modal/ok-message/ok-message.component";

@Component({
  selector: 'app-vehicle-sum-insured',
  standalone: true,
  imports: [
    SharedModule,
    SumInsuredFormatterDirective,
    NxSmallStageModule,
    TextFieldModule
  ],
  templateUrl: './vehicle-sum-insured.component.html',
  styleUrl: './vehicle-sum-insured.component.scss'
})
export class VehicleSumInsuredComponent {

  @Select(SatMotorState.endtStep2EndorsementDetails) endtEndorsementDetailsData$;
  @Select(SatMotorState.endtCoveragePremium) endtCoveragePremium$: Observable<SatMotorState>;
  private destroy$ = new Subject<void>();

  @Input() endorsementType: any;
  @Output() endtCalculatePremium = new EventEmitter<unknown>();

  isPrivateCar: boolean;
  isMotorcycle: boolean;
  isComprehensive: boolean;
  isThirdPartyFireTheft: boolean;
  isThirdParty: boolean;

  issuanceInfo: any;
  vehicleNo: any;
  vehicleSumInsured: any;
  previousSumInsured: any;
  coverCode: any;
  coverDescp: any;
  vehicleClass: any;

  agentDetail: any;

  region: any;
  sumInsuredRange: boolean;
  avSi: any;
  avSiAvailable: boolean;
  underInsuranceApplies: boolean;
  avIndChecked: boolean;
  sumInsuredOriginal: any;
  showIndemnityPopup: boolean = false;

  oldValue = {};

  decimalFmt: any;
  numberFmt: any;

  endtVehiclePolicyData: any;
  endtPreviousVehiclePolicyData: any;

  vehicleSumInsuredForm: FormGroup;

  warningMessageModal?: NxModalRef<SimpleModalComponent>;

  constructor(
    private readonly dialogService: NxDialogService,
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef,
    private router: Router,
    public store: Store
  ) {
    this.decimalFmt = new FormatDecimalPipe();
    this.numberFmt = new RemoveCommaPipe();

    this.vehicleSumInsuredForm = this.fb.group({
      sumInsured: ["", [Validators.required]],
      avInd: [{value: false, disabled: true}],
    });
  }

  ngOnInit() {

    this.agentDetail = this.store.selectSnapshot<any>((state) => state.SatMotorState.endorsement.step1.agentDetail);
    this.issuanceInfo = this.store.selectSnapshot<any>((state) => state.SatMotorState.endorsement.step1.issuance.issuance);
    this.vehicleNo = this.issuanceInfo.vehicleNo;

    this.loadVehicleSumInsured();
    // this.loadEndorsementDetailsData();

    this.vehicleSumInsured = this.store.selectSnapshot<any>((state) => state.SatMotorState.endorsement?.step2?.endorsementDetails?.vehicleSumInsured);

    this.endtVehiclePolicyData = this.store.selectSnapshot<any>(state => state.SatMotorState?.endorsement?.step1?.endtVehicleData);
    this.endtPreviousVehiclePolicyData = this.store.selectSnapshot<any>(state => state.SatMotorState?.endorsement?.step1?.endtPreviousVehicleData);

    const endtVehiclePolicyData = this.endtVehiclePolicyData
    const endtPreviousVehiclePolicyData = this.endtPreviousVehiclePolicyData

    let riskList = endtVehiclePolicyData?.riskList;
    let coverList = endtVehiclePolicyData?.riskList[0]?.coverList;

    let data = coverList[0];

    this.vehicleClass = riskList[0].vehicleClass; //type of vehicle class, ex: "01" for motorcycle, "02" for private car 
    this.coverCode = data.coverCode; //type of coverage code, ex: "01"
    this.coverDescp = data.coverDescp; //type of coverage description, ex: "COMPREHENSIVE"
    this.previousSumInsured = formatNumber(data.previousSumInsured, 'en-US');
    this.sumInsuredOriginal = this.decimalFmt.transform(data.sumInsured);
    this.region = endtVehiclePolicyData.region;

    if (this.vehicleClass == "01") {
      this.allVehicleClassFalse();
      this.isMotorcycle = true;
    } else if (this.vehicleClass == "02") {
      this.allVehicleClassFalse();
      this.isPrivateCar = true;
    }

    switch (this.coverCode) {
      case '01':
        this.allCoverageTypeFalse();
        this.isComprehensive = true;
        break;
      case '20':
        this.allCoverageTypeFalse();
        this.isThirdParty = true;
        break;
      case '30':
        this.allCoverageTypeFalse();
        this.isThirdPartyFireTheft = true;
        break;
    }

    if (endtVehiclePolicyData && !this.vehicleSumInsured) {
      if (coverList) {


        this.vehicleSumInsuredForm.patchValue({
          sumInsured: this.decimalFmt.transform(data.sumInsured),
          avInd: riskList[0].avInd,
        });
        if (riskList && riskList.length) {
          console.log("riskList:", riskList);
          this.setRecommendedSumInsuredRange(riskList[0]);
          this.setSumInsuredRange(riskList[0].coverList[0].sumInsured);
          this.setAgreedValue();

          if (this.endorsementType === 'ENDT30') {
            this.showIndemnityPopup = this.avIndChecked;
          }
        }
      } else {
        console.error("coverList cannot populate vehicleSumInsuredForm");
      }
    } else if (endtVehiclePolicyData && this.vehicleSumInsured) {

      // console.log("this.vehicleSumInsured:", this.vehicleSumInsured);

      this.region = endtVehiclePolicyData.region;
      this.vehicleSumInsuredForm.patchValue({
        sumInsured: this.decimalFmt.transform(this.vehicleSumInsured.sumInsured),
        avInd: this.vehicleSumInsured.avInd,
      });

      if (riskList && riskList.length) {
        console.log("riskList:", riskList);
        this.setRecommendedSumInsuredRange(riskList[0]);
        this.setSumInsuredRange(riskList[0].coverList[0].sumInsured);
        this.setAgreedValue();

        if (this.endorsementType === 'ENDT30') {
          this.showIndemnityPopup = this.avIndChecked;
        }
      }
    } else {
      console.error("endtVehiclePolicyData is undefined");
    }

    this.loadPremiumCalculation();
  }

  isShowIndemnityPopup() {
    if (this.showIndemnityPopup && !this.avIndChecked) {
      this.showIndemnityPopup = false;
      this.dialogService.open(OkMessageComponent, {
        disableClose: true,
        width: "400px",
        data: {
          message: "The vehicle is on Indemnity Value.",
        },
      });
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  allVehicleClassFalse() {
    this.isPrivateCar = false;
    this.isMotorcycle = false;
  }

  allCoverageTypeFalse() {
    this.isComprehensive = false;
    this.isThirdPartyFireTheft = false;
    this.isThirdParty = false;
  }

  onChangeForm($event: any) {

    const data = {
      fieldName: $event.target.getAttribute("formControlName"),
      value: $event.target.value,
      oldValue: this.oldValue[$event.target.getAttribute("formControlName")],
    };

    this.underInsuranceApplies = false;

    if (!data.value || data.value < 10000) {
      const siWarning = this.setSIWarning(data.value);
      console.log("sumInsured:", data.value);

      if (!siWarning.valid) {
        this.showSIWarning(siWarning.value);
        return;
      }
    }

    if (data.value) {
      const value = this.numberFmt.transform(data.value);
      if (value > 0) {
        const siMaxValue = 50000000;
        if (value > siMaxValue) {
          this.dialogService.open(SimpleModalComponent, {
            showCloseIcon: false, width: "400px", maxWidth: "400px",
            disableClose: true,
            data: { type: "Warning", message: "Maximum sum insured exceeded system limit." },
          })
            .afterClosed().subscribe((result) => {
              this.sumInsured.setValue(0);
            });
          return;
        }
      }
    }

    if (data.oldValue !== data.value) {
      this.vehicleSumInsuredForm.patchValue({
        avInd: false,
      });
      this.storeEndorsementDetailsData();
    }
  }

  loadVehicleSumInsured() {
    this.vehicleSumInsuredForm = this.fb.group({
      sumInsured: ["", Validators.required],
      avInd: false,
    });
  }

  loadPremiumCalculation() {
    this.endtCoveragePremium$.pipe(takeUntil(this.destroy$)).subscribe((state) => {

      let cngeNoteDto = this.endtVehiclePolicyData;

      if (state) {
        const data = state["data"];
        if (data) 
          cngeNoteDto = data["cngeNoteDto"];
      }

      this.avSi = null;
      this.sumInsuredRange = this.avSiAvailable = this.underInsuranceApplies = this.avIndChecked = false;

      if (cngeNoteDto) {
        this.region = cngeNoteDto.region;

        const riskList = cngeNoteDto["riskList"];

        if (riskList?.length) {
          for (let riskListItem of riskList) {

            const coverList = riskListItem["coverList"];
            if (coverList?.length) {
              for (let coverListItem of coverList) {

                const sumInsured = coverListItem["sumInsured"];

                this.setRecommendedSumInsuredRange(riskListItem);
                console.log("riskListItem:", riskListItem);

                if (sumInsured) {
                  const siWarning = this.setSIWarning(sumInsured);
                  console.log("sumInsured:", sumInsured);

                  if (!siWarning.valid)
                    this.showSIWarning(siWarning.value);

                  this.setSumInsuredRange(sumInsured);

                  if ([siWarning.valid].indexOf(true) != -1 && !this.sumInsuredRange)
                    this.setUnderInsuranceApplies(sumInsured);

                  this.setAgreedValue();

                  if (this.endorsementType === 'ENDT30') {
                    this.isShowIndemnityPopup();
                  }
                }
              }
            }

          }
        }
      }
    });

    this.avInd.disable();
  }

  loadEndorsementDetailsData() {
    this.endtEndorsementDetailsData$.subscribe((state) => {
      if (state) {
        if (state.vehicleSumInsured) {
          this.vehicleSumInsuredForm.patchValue(this.decimalFmt.transform(state.vehicleSumInsured));
        }
      }
    });
  }

  setRecommendedSumInsuredRange(riskListItem) {
    this.avSi = {
      E: {
        avSiMin: riskListItem.avEmSiMin, avSiMinDesc: formatNumber(Number(riskListItem.avEmSiMin), 'en-US'),
        avSiMax: riskListItem.avEmSiMax, avSiMaxDesc: formatNumber(Number(riskListItem.avEmSiMax), 'en-US'),
      },
      W: {
        avSiMin: riskListItem.avWmSiMin, avSiMinDesc: formatNumber(Number(riskListItem.avWmSiMin), 'en-US'),
        avSiMax: riskListItem.avWmSiMax, avSiMaxDesc: formatNumber(Number(riskListItem.avWmSiMax), 'en-US'),
      },
    };
    console.log("setRecommendedSumInsuredRange this.avSi:", this.avSi);

    if (this.avSi) {
      this.avSiAvailable = this.avSi[this.region].avSiMin > 0 && this.avSi[this.region].avSiMax > 0;
      console.log("setRecommendedSumInsuredRange this.avSiAvailable:", this.avSiAvailable);
    }
  }

  setSumInsuredRange(sumInsured) {
    return this.sumInsuredRange = (this.avSiAvailable) &&
      ((sumInsured >= this.avSi[this.region].avSiMin) && (sumInsured <= this.avSi[this.region].avSiMax));
  }

  setAgreedValue() {
    this.avIndChecked = this.avSi[this.region] && this.sumInsuredRange;
    this.avInd.patchValue(this.avIndChecked);
  }

  setSIWarning(sumInsured: any) {
    let value: any;
    if (this.isPrivateCar && this.isComprehensive && sumInsured < 10000) {
      value = "10000";
    
    } else if (this.isPrivateCar && this.isThirdPartyFireTheft && sumInsured < 4000) {
      value = "4000";
    
    } else if (this.isMotorcycle && (this.isComprehensive || this.isThirdPartyFireTheft) && sumInsured < 1000) {
      value = "1000";
    }

    if (value) {
      return { valid: false, value: value };
    }
    return { valid: true };
  }

  showSIWarning(value: any) {
    if (value) {
      this.warningMessageModal = this.dialogService.open(SimpleModalComponent, {
        showCloseIcon: false, width: "400px", maxWidth: "400px",
        disableClose: true,
        data: { type: "Warning", message: "Sum insured must be at least RM" + formatNumber(Number(value), 'en-US') + "." },
      });

      this.warningMessageModal.afterClosed().subscribe((result) => {
        this.sumInsured.setValue(this.decimalFmt.transform(value));
        this.storeEndorsementDetailsData();
      });
    }
  }


  setUnderInsuranceApplies(sumInsured) {
    return this.underInsuranceApplies = sumInsured < ((90 / 100) * this.avSi[this.region].avSiMin)
  }

  validateChangedFields() {
    let sumInsuredOriginal = this.sumInsuredOriginal;
    let sumInsured = this.normalizeValue(this.vehicleSumInsuredForm.get('sumInsured')?.value);
    let hasChanged = false;

    if (sumInsuredOriginal === undefined) {
      console.error(`Original value for sumInsuredOriginal is undefined`);
    }

    sumInsuredOriginal = this.convertToComparableType(sumInsuredOriginal, sumInsured);
    sumInsured = this.convertToComparableType(sumInsured, sumInsuredOriginal);

    if (sumInsuredOriginal !== sumInsured) {
      hasChanged = true;
    } else {
      hasChanged = false;
    }
    console.log("Final hasChanged result:", hasChanged);
    return hasChanged;
  }

  normalizeValue(value: any) {
    if (typeof value === 'string') {
      return value.trim().toLowerCase();
    }
    return value;
  }

  convertToComparableType(value: any, referenceValue: any) {
    if (typeof referenceValue === 'number' && !isNaN(Number(value))) {
      return Number(value);
    }
    if (typeof referenceValue === 'string') {
      return String(value);
    }
    return value;
  }

  /////////////////////////////////////////////////////
  get sumInsured() {
    return this.vehicleSumInsuredForm.controls["sumInsured"];
  }

  get avInd() {
    return this.vehicleSumInsuredForm.controls["avInd"];
  }
  ///////////////////////////////////////////////////

  storeEndorsementDetailsData() {

    const sumInsured = this.vehicleSumInsuredForm.controls['sumInsured'];
    if (sumInsured.value <= 0) {
      sumInsured.setErrors({"isZero": true});       
      sumInsured.markAllAsTouched(); 
      return;
    } else {
      sumInsured.setErrors(null);
      sumInsured.updateValueAndValidity();
    }

    if (this.vehicleSumInsuredForm.valid) {
      let vehicleSumInsured = this.vehicleSumInsuredForm.getRawValue();
      console.log('Saving Vehicle Sum Insured Data:', vehicleSumInsured);

      let payload = {
        vehicleSumInsured: { ...vehicleSumInsured, sumInsured: this.numberFmt.transform(vehicleSumInsured.sumInsured) },
        isVehicleSumInsured: true
      }
      console.log('Saving Vehicle Sum Insured Data:', payload);
      this.store.dispatch(new STORE_ENDORSEMENT(payload));

      let endtUpdatedData = this.store.selectSnapshot<any>(state => state.SatMotorState?.endorsement?.step2?.endtUpdatedData);
      if (!endtUpdatedData) {
        endtUpdatedData = this.endtVehiclePolicyData
      }

      //need to test the endtUpdatedData to include the vehicle sum insured
      endtUpdatedData = {
        ...endtUpdatedData,
        sumInsured: payload.vehicleSumInsured.sumInsured,
        riskList: [{
          ...endtUpdatedData.riskList[0],
          avInd: this.avIndChecked,
          coverList: [{
            ...endtUpdatedData.riskList[0].coverList[0],
            sumInsured: payload.vehicleSumInsured.sumInsured,
            avInd: this.avIndChecked,
          }]
        }]
      };
      this.store.dispatch(new UPDATE_ENDORSEMENT_STEP2({
        isReset: false,
        cngeNote: endtUpdatedData
      })).subscribe(() => {
        this.endtCalculatePremium.emit();
      });
      

    } else {
      console.error('Vehicle Sum Insured form is invalid!');
      // this.logFormErrors(this.vehicleSumInsuredForm);
      this.vehicleSumInsuredForm.markAllAsTouched();
    }
  }

}
